/**
 * Gets the first valid character from a name, skipping common placeholders like '-'
 */
export function getInitial(name: string | undefined | null): string {
  if (!name) return '';
  const trimmed = name.trim();
  if (!trimmed) return '';
  
  // Skip leading non-alphanumeric characters (like '-' or '.')
  const match = trimmed.match(/[a-zA-Z0-9ÇçĞğİiIıÖöŞşÜü]/);
  return match ? match[0] : '';
}

/**
 * Calculates user initials from first and last name
 */
export function calculateInitials(firstName: string | undefined | null, lastName: string | undefined | null, locale = 'tr'): string {
  const first = getInitial(firstName);
  const last = getInitial(lastName);
  return (first + last).toLocaleUpperCase(locale);
}
